// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tLLZ5","buttons":"styles_buttons__3xihp"};